import { Building2, CalendarClock, DollarSign, MailPlus } from "lucide-react"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { formatCurrencyCents } from "@/lib/sponsor"

export interface SponsorStats {
  totalRaisedCents: number
  raisedThisMonthCents: number
  activeProjects: number
  pendingInvites: number
}

export function SponsorStatCards({ stats }: { stats: SponsorStats }) {
  const cards = [
    {
      title: "Total raised",
      value: formatCurrencyCents(stats.totalRaisedCents),
      hint: "All projects, all time",
      icon: DollarSign,
    },
    {
      title: "Raised this month",
      value: formatCurrencyCents(stats.raisedThisMonthCents),
      hint: "Succeeded donations",
      icon: CalendarClock,
    },
    {
      title: "Active projects",
      value: String(stats.activeProjects),
      hint: "Active or transferring",
      icon: Building2,
    },
    {
      title: "Pending invites",
      value: String(stats.pendingInvites),
      hint: "Awaiting project leader",
      icon: MailPlus,
    },
  ]

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {cards.map(({ title, value, hint, icon: Icon }) => (
        <Card key={title}>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">{title}</CardTitle>
            <Icon className="h-4 w-4 text-muted-foreground" aria-hidden />
          </CardHeader>
          <CardContent>
            <p className="text-2xl font-bold">{value}</p>
            <p className="text-xs text-muted-foreground">{hint}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
